import { useParams } from "react-router-dom";
import {
  useGetResellerStoresInfiniteQuery,
  useCreateResellerStoreMutation,
} from "../query/storesQuery";
import { StoreListPage } from "./components/StoreListPage";

export const ResellerStoresView = () => {
  const { resellerId } = useParams<{ resellerId: string }>();
  const { data: storesData, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } = useGetResellerStoresInfiniteQuery(resellerId);
  const { mutateAsync: createStore, isPending: createLoading } = useCreateResellerStoreMutation(
    resellerId
  );
  const allStores = storesData?.pages.flatMap((page) => page) ?? [];

  return (
    <StoreListPage
      allStores={allStores}
      isLoading={isLoading}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage ?? false}
      isFetchingNextPage={isFetchingNextPage}
      searchResellerId={resellerId}
      onCreateStore={(data) => {
        return createStore(data);
      }}
      createLoading={createLoading}
    />
  );
};
